import Cookie from 'utils/cookies';
import { OPEN_SEARCH_COOKIE, OPEN_SEARCH_EXPIERY_DAYS } from 'constants/index';

export function isSessionStorage() {
  return typeof sessionStorage === 'object';
}
function updateSearchOverlayVisibility(status) {
  if (isSessionStorage()) {
    const isShow = status ? 'yes' : 'no';
    sessionStorage.setItem('isShowSearchOverlay', isShow);
  }
}
function isSearchOverlayAlreadyShown() {
  if (isSessionStorage()) {
    const isShown = sessionStorage.getItem('isSearchOverlayAlreadyShown');
    return !!(isShown && isShown === 'yes');
  }
  return false;
}

export function getSearchPageViewCount() {
  try {
    if (isSessionStorage) {
      const searchPageViewCount = sessionStorage.getItem(
        'searchOverlayPageViewCount',
      );
      return searchPageViewCount ? parseInt(searchPageViewCount, 10) : 0;
    }
    return 0;
  } catch (e) {
    console.log(e);
    return 0;
  }
}

function checkAndUpdateSearchOverlayVisibility() {
  const searchOverlayPageViewvisibilityLimit =
    typeof window !== 'undefined' &&
    typeof window.searchOverlayPageViewLimit !== 'undefined'
      ? window.searchOverlayPageViewLimit
      : 10;
  const searchPageViewCount = getSearchPageViewCount();
  if (searchPageViewCount >= searchOverlayPageViewvisibilityLimit) {
    updateSearchOverlayVisibility(true);
  }
}

export function isShowSearchOverlay() {
  if (isSessionStorage()) {
    const isShow = sessionStorage.getItem('isShowSearchOverlay');
    return !!(isShow && isShow === 'yes' && !isSearchOverlayAlreadyShown());
    // return !!(isShow && isShow === 'yes');
  }
  return false;
}
export function showSearchOverlayPopuponPageView() {
  const searchOverlayPageViewvisibilityLimit =
    typeof window !== 'undefined' &&
    typeof window.searchOverlayPageViewLimit !== 'undefined'
      ? window.searchOverlayPageViewLimit
      : 10;
  if (
    sessionStorage.getItem('searchOverlayPageViewCount') >=
    searchOverlayPageViewvisibilityLimit
  )
    return true;
  return false;
}

export function updateSearchOverlayPageViewCount() {
  if (isSessionStorage()) {
    let searchPageViewCount = getSearchPageViewCount();
    searchPageViewCount += 1;
    sessionStorage.setItem('searchOverlayPageViewCount', searchPageViewCount);
    checkAndUpdateSearchOverlayVisibility();
  }
}

export function setSearchOverLayAlreadyShown() {
  if (isSessionStorage()) {
    sessionStorage.setItem('isSearchOverlayAlreadyShown', 'yes');
  }
}

function saveRecentSearch(recentSearch) {
  if (typeof localStorage === 'object') {
    localStorage.setItem('recentSearch', recentSearch);
  }
}

function checkIfRecentSearchKeyAlreadyExist(recentArray, searcedhKey) {
  let matchIndex = -1;
  for (let i = 0; i < recentArray.length; i += 1) {
    if (
      recentArray &&
      searcedhKey &&
      recentArray[i] &&
      recentArray[i].toLowerCase() === searcedhKey.toLowerCase()
    ) {
      matchIndex = i;
      break;
    }
  }
  return matchIndex;
}

export function getRecentSearch() {
  try {
    if (typeof localStorage === 'object') {
      let recentSearches = localStorage.getItem('recentSearch');
      recentSearches =
        recentSearches &&
        typeof recentSearches === 'string' &&
        JSON.parse(recentSearches);
      if (Array.isArray(recentSearches)) {
        return recentSearches.length > 5
          ? recentSearches.slice(0, 5)
          : recentSearches;
      }
    }
    return [];
  } catch (e) {
    return [];
  }
}

export function processRecentSearch(searchKey) {
  if (typeof localStorage === 'object' && searchKey) {
    const recentSearches = getRecentSearch();
    if (
      Array.isArray(recentSearches) &&
      checkIfRecentSearchKeyAlreadyExist(recentSearches, searchKey) < 0
    ) {
      recentSearches.unshift(searchKey);
      saveRecentSearch(JSON.stringify(recentSearches));
    }
  }
}

export function removeRecentSearchItem(searchKey) {
  let recentSearches = getRecentSearch();
  if (Array.isArray(recentSearches) && recentSearches.length) {
    const matchedIndex = checkIfRecentSearchKeyAlreadyExist(
      recentSearches,
      searchKey,
    );
    if (matchedIndex > -1) {
      recentSearches = recentSearches.filter((v, i) => i !== matchedIndex);
      if (Array.isArray(recentSearches) && recentSearches.length) {
        saveRecentSearch(JSON.stringify(recentSearches));
      } else {
        saveRecentSearch(JSON.stringify([]));
      }
    }
  }
  return recentSearches;
}

export function filterDuplicateTrendingEntry(trensingData) {
  const recentSearches = getRecentSearch();
  if (
    Array.isArray(recentSearches) &&
    recentSearches.length &&
    trensingData &&
    Array.isArray(trensingData.items) &&
    trensingData.items.length
  ) {
    const trendingItems = trensingData.items.filter(
      v => checkIfRecentSearchKeyAlreadyExist(recentSearches, v.hl) < 0,
    );
    return { items: trendingItems };
  }
  return trensingData;
}

export function isPageExcluded() {
  const excludeUrl = [
    '/toi-plus/plans',
    'most-searched-products',
    '/business/budget/budget-survey',
  ];
  const curURL = window.location.href;
  let isExclude = false;
  for (let i = 0; i < excludeUrl.length; i += 1) {
    const temp = excludeUrl[i];
    if (curURL.indexOf(temp) > -1) {
      isExclude = true;
      break;
    }
  }
  return isExclude;
}

export function setSearchBarShownCookie(isFirst = false) {
  Cookie.set(
    OPEN_SEARCH_COOKIE,
    'yes',
    isFirst ? 6 : OPEN_SEARCH_EXPIERY_DAYS,
    '/',
  );
  if (isFirst) {
    Cookie.set('searchbarvisible', 'yes', 1, '/');
  } else {
    Cookie.remove('searchbarvisible', '/');
  }
}

export function checkSearchBarShownCookieExists() {
  const isSearchBarShown = Cookie.get(OPEN_SEARCH_COOKIE);
  const isSearchbarvisible = Cookie.get('searchbarvisible');
  if (isPageExcluded()) {
    return false;
  }
  if (isSearchBarShown !== 'yes' && isSearchbarvisible !== 'yes') {
    return 1;
  } else if (isSearchBarShown === 'yes' && isSearchbarvisible === 'yes') {
    return 2;
  }
  return false;
}

export function isSearchedKeywordValid(searchKeyword) {
  if (!searchKeyword) return false;
  const allowedterm = /^[-@.,'\/#&+\w\s]*$/;
  if (searchKeyword.match(allowedterm)) {
    return true;
  }
  return false;
}

export function replaceSpaceWitHyphen(text) {
  if (text) return text.replace(/\s+/g, '-').toLowerCase();
  return text;
}

export default {
  isSessionStorage,
  isShowSearchOverlay,
  updateSearchOverlayPageViewCount,
  setSearchOverLayAlreadyShown,
  getRecentSearch,
  processRecentSearch,
  removeRecentSearchItem,
  filterDuplicateTrendingEntry,
  isPageExcluded,
  checkSearchBarShownCookieExists,
  setSearchBarShownCookie,
  getSearchPageViewCount,
  showSearchOverlayPopuponPageView,
  isSearchedKeywordValid,
  replaceSpaceWitHyphen,
};
